import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-candidate-configuration',
  templateUrl: './candidate-configuration.component.html',
  styleUrls: ['./candidate-configuration.component.scss']
})
export class CandidateConfigurationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
